/* ===== Avatar Component ===== */

export interface AvatarProps {
  src?: string | null
  name?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  status?: 'online' | 'offline' | 'busy'
}

const sizeMap = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
}

const statusMap = {
  online: 'bg-success-500',
  offline: 'bg-neutral-400',
  busy: 'bg-danger-500',
}

export function Avatar({ src, name = 'U', size = 'md', className = '', status }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()

  return (
    <div className="relative inline-block">
      {src ? (
        <img
          src={src}
          alt={name}
          className={`rounded-[13px] border border-neutral-200 object-cover dark:border-neutral-700 ${sizeMap[size]} ${className}`}
        />
      ) : (
        <div
          className={`flex items-center justify-center rounded-[13px] border border-primary-200 bg-primary-50 font-bold text-primary-700 dark:border-primary-500/30 dark:bg-primary-500/15 dark:text-primary-200 ${sizeMap[size]} ${className}`}
        >
          {initials}
        </div>
      )}
      {status && (
        <span
          className={`absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white dark:ring-neutral-900 ${statusMap[status]}`}
        />
      )}
    </div>
  )
}
